"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var ksys_app_template_1 = require("@kurtosys/ksys-app-template");
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../shared");
var Wrapper_1 = __importDefault(require("./styledComponents/Wrapper"));
var RadioButtonInput_1 = __importDefault(require("./styledComponents/RadioButtonInput"));
var RadioButtonLabel_1 = __importDefault(require("./styledComponents/RadioButtonLabel"));
var RadioButtonLabelText_1 = __importDefault(require("./styledComponents/RadioButtonLabelText"));
var Icon_1 = __importDefault(require("../Icon/Icon"));
var RadioButtons_meta_1 = require("./RadioButtons.meta");
var RadioButtons = /** @class */function (_super) {
  __extends(RadioButtons, _super);
  function RadioButtons(props) {
    var _this = _super.call(this, props) || this;
    _this.categoryKey = RadioButtons_meta_1.RADIO_BUTTONS_CATEGORY_KEY;
    _this.componentKey = RadioButtons_meta_1.RADIO_BUTTONS_COMPONENT_KEY;
    _this.handleOptionChange = function (event) {
      var optionIndex = parseInt(event.target.value, 10);
      var _a = _this.props.options,
        options = _a === void 0 ? [] : _a;
      _this.value = options.length > optionIndex ? options[optionIndex].value : undefined;
      var onChange = _this.props.onChange;
      if (onChange) {
        onChange(_this.value);
      }
    };
    _this.value = props.value;
    return _this;
  }
  RadioButtons.prototype.componentDidUpdate = function (previousProps) {
    var value = this.props.value;
    var valueChanged = previousProps.value !== value;
    if (valueChanged) {
      this.value = value;
    }
  };
  RadioButtons.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      className = _a.className,
      _b = _a.name,
      name = _b === void 0 ? ksys_app_template_1.utils.guid.generateGuid() : _b,
      _c = _a.options,
      options = _c === void 0 ? [] : _c,
      _d = _a.labelPosition,
      labelPosition = _d === void 0 ? 'after' : _d,
      _e = _a.disabled,
      disabled = _e === void 0 ? false : _e,
      selectedOptionStyle = _a.selectedOptionStyle,
      selectedOptionIcon = _a.selectedOptionIcon;
    return react_1.default.createElement(Wrapper_1.default, {
      className: className
    }, options.map(function (option, optionIndex) {
      var value = option.value,
        label = option.label;
      var componentStyle = _this.value === value ? selectedOptionStyle : {};
      return react_1.default.createElement(RadioButtonLabel_1.default, {
        key: value,
        componentStyle: componentStyle
      }, labelPosition === 'before' && react_1.default.createElement(RadioButtonLabelText_1.default, null, label), react_1.default.createElement(RadioButtonInput_1.default, {
        type: "radio",
        name: name,
        value: optionIndex,
        checked: _this.value === value,
        onChange: _this.handleOptionChange,
        disabled: disabled
      }), labelPosition === 'after' && react_1.default.createElement(RadioButtonLabelText_1.default, null, label), selectedOptionIcon && _this.value === value && react_1.default.createElement(Icon_1.default, __assign({}, selectedOptionIcon)));
    }));
  };
  __decorate([mobx_1.observable], RadioButtons.prototype, "value", void 0);
  RadioButtons = __decorate([mobx_react_1.observer], RadioButtons);
  return RadioButtons;
}(shared_1.ComponentBase);
exports.RadioButtons = RadioButtons;
exports.default = shared_1.InjectedStyledComponent(RadioButtons, RadioButtons_meta_1.RADIO_BUTTONS_CATEGORY_KEY, RadioButtons_meta_1.RADIO_BUTTONS_COMPONENT_KEY);